export const hasMeaningfulChange = (original, updated, fields) => {
  return fields.some((field) => {
    const origValue =
      original[field] === null || original[field] === undefined
        ? null
        : original[field];

    const updatedValue =
      updated[field] === '' || updated[field] === undefined
        ? null
        : updated[field];

    return origValue !== updatedValue;
  });
};